"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
/* CONSTS */
var Consts = {
    key2id: {
        /* MODIFIERS */
        alt: 256,
        option: 256,
        cmd: 512,
        command: 512,
        meta: 512,
        ctrl: 1024,
        control: 1024,
        shift: 2048,
        cmdorctrl: utils_1.default.isMac ? 512 : 1024,
        commandorcontrol: utils_1.default.isMac ? 512 : 1024,
        /* SPECIAL CHARACTERS */
        backspace: 1,
        capslock: 2,
        del: 3,
        delete: 3,
        down: 4,
        end: 5,
        enter: 6,
        return: 6,
        esc: 7,
        escape: 7,
        home: 8,
        insert: 9,
        left: 10,
        pagedown: 11,
        pageup: 12,
        right: 13,
        space: 14,
        spacebar: 14,
        tab: 15,
        up: 16,
        /* DIGITS */
        0: 17,
        1: 18,
        2: 19,
        3: 20,
        4: 21,
        5: 22,
        6: 23,
        7: 24,
        8: 25,
        9: 26,
        /* ALPHABET */
        a: 27,
        b: 28,
        c: 29,
        d: 30,
        e: 31,
        f: 32,
        g: 33,
        h: 34,
        i: 35,
        j: 36,
        k: 37,
        l: 38,
        m: 39,
        n: 40,
        o: 41,
        p: 42,
        q: 43,
        r: 44,
        s: 45,
        t: 46,
        u: 47,
        v: 48,
        w: 49,
        x: 50,
        y: 51,
        z: 52,
        /* PUNCTUATION */
        '!': 53,
        '"': 54,
        '#': 55,
        '$': 56,
        '%': 57,
        '&': 58,
        '\'': 59,
        '(': 60,
        ')': 61,
        '*': 62,
        '+': 63,
        plus: 63,
        ',': 64,
        '-': 65,
        '.': 66,
        '/': 67,
        ':': 68,
        ';': 69,
        '<': 70,
        '=': 71,
        '>': 72,
        '?': 73,
        '@': 74,
        '[': 75,
        '\\': 76,
        ']': 77,
        '^': 78,
        '_': 79,
        '`': 80,
        '{': 81,
        '|': 82,
        '}': 83,
        '~': 84,
        /* FUNCTION KEYS */
        f1: 85,
        f2: 86,
        f3: 87,
        f4: 88,
        f5: 89,
        f6: 90,
        f7: 91,
        f8: 92,
        f9: 93,
        f10: 94,
        f11: 95,
        f12: 96,
        f13: 97,
        f14: 98,
        f15: 99,
        f16: 100,
        f17: 101,
        f18: 102,
        f19: 103,
        f20: 104,
        f21: 105,
        f22: 106,
        f23: 107,
        f24: 108,
        /* NUMPAD DIGITS */
        numpad0: 109,
        numpad1: 110,
        numpad2: 111,
        numpad3: 112,
        numpad4: 113,
        numpad5: 114,
        numpad6: 115,
        numpad7: 116,
        numpad8: 117,
        numpad9: 118
    },
    code2id: {
        /* MODIFIERS */
        18: 256,
        91: 512,
        92: 512,
        93: 512,
        224: 512,
        17: 1024,
        16: 2048,
        /* SPECIAL CHARACTERS */
        8: 1,
        20: 2,
        46: 3,
        40: 4,
        35: 5,
        13: 6,
        27: 7,
        36: 8,
        45: 9,
        37: 10,
        34: 11,
        33: 12,
        39: 13,
        32: 14,
        9: 15,
        38: 16,
        /* FUNCTION KEYS */
        112: 85,
        113: 86,
        114: 87,
        115: 88,
        116: 89,
        117: 90,
        118: 91,
        119: 92,
        120: 93,
        121: 94,
        122: 95,
        123: 96,
        124: 97,
        125: 98,
        126: 99,
        127: 100,
        128: 101,
        129: 102,
        130: 103,
        131: 104,
        132: 105,
        133: 106,
        134: 107,
        135: 108,
        /* NUMPAD DIGITS */
        96: 109,
        97: 110,
        98: 111,
        99: 112,
        100: 113,
        101: 114,
        102: 115,
        103: 116,
        104: 117,
        105: 118 // numpad9
    },
    id2shortcut: {
        /* MODIFIERS */
        256: 'Alt',
        512: 'Cmd',
        1024: 'Ctrl',
        2048: 'Shift',
        /* SPECIAL CHARACTERS */
        1: 'Backspace',
        2: 'Capslock',
        3: 'Delete',
        4: 'Down',
        5: 'End',
        6: 'Enter',
        7: 'Escape',
        8: 'Home',
        9: 'Insert',
        10: 'Left',
        11: 'PageDown',
        12: 'PageUp',
        13: 'Right',
        14: 'Space',
        15: 'Tab',
        16: 'Up',
        /* DIGITS */
        17: '0',
        18: '1',
        19: '2',
        20: '3',
        21: '4',
        22: '5',
        23: '6',
        24: '7',
        25: '8',
        26: '9',
        /* ALPHABET */
        27: 'A',
        28: 'B',
        29: 'C',
        30: 'D',
        31: 'E',
        32: 'F',
        33: 'G',
        34: 'H',
        35: 'I',
        36: 'J',
        37: 'K',
        38: 'L',
        39: 'M',
        40: 'N',
        41: 'O',
        42: 'P',
        43: 'Q',
        44: 'R',
        45: 'S',
        46: 'T',
        47: 'U',
        48: 'V',
        49: 'W',
        50: 'X',
        51: 'Y',
        52: 'Z',
        /* PUNCTUATION */
        53: '!',
        54: '"',
        55: '#',
        56: '$',
        57: '%',
        58: '&',
        59: '\'',
        60: '(',
        61: ')',
        62: '*',
        63: 'Plus',
        64: ',',
        65: '-',
        66: '.',
        67: '/',
        68: ':',
        69: ';',
        70: '<',
        71: '=',
        72: '>',
        73: '?',
        74: '@',
        75: '[',
        76: '\\',
        77: ']',
        78: '^',
        79: '_',
        80: '`',
        81: '{',
        82: '|',
        83: '}',
        84: '~',
        /* FUNCTION KEYS */
        85: 'F1',
        86: 'F2',
        87: 'F3',
        88: 'F4',
        89: 'F5',
        90: 'F6',
        91: 'F7',
        92: 'F8',
        93: 'F9',
        94: 'F10',
        95: 'F11',
        96: 'F12',
        97: 'F13',
        98: 'F14',
        99: 'F15',
        100: 'F16',
        101: 'F17',
        102: 'F18',
        103: 'F19',
        104: 'F20',
        105: 'F21',
        106: 'F22',
        107: 'F23',
        108: 'F24',
        /* NUMPAD DIGITS */
        109: 'Numpad0',
        110: 'Numpad1',
        111: 'Numpad2',
        112: 'Numpad3',
        113: 'Numpad4',
        114: 'Numpad5',
        115: 'Numpad6',
        116: 'Numpad7',
        117: 'Numpad8',
        118: 'Numpad9'
    },
    id2accelerator: {
        /* MODIFIERS */
        256: 'Alt',
        512: 'Cmd',
        1024: 'Ctrl',
        2048: 'Shift',
        /* SPECIAL CHARACTERS */
        1: 'Backspace',
        2: 'Capslock',
        3: 'Delete',
        4: 'Down',
        5: 'End',
        6: 'Enter',
        7: 'Escape',
        8: 'Home',
        9: 'Insert',
        10: 'Left',
        11: 'PageDown',
        12: 'PageUp',
        13: 'Right',
        14: 'Space',
        15: 'Tab',
        16: 'Up',
        /* DIGITS */
        17: '0',
        18: '1',
        19: '2',
        20: '3',
        21: '4',
        22: '5',
        23: '6',
        24: '7',
        25: '8',
        26: '9',
        /* ALPHABET */
        27: 'A',
        28: 'B',
        29: 'C',
        30: 'D',
        31: 'E',
        32: 'F',
        33: 'G',
        34: 'H',
        35: 'I',
        36: 'J',
        37: 'K',
        38: 'L',
        39: 'M',
        40: 'N',
        41: 'O',
        42: 'P',
        43: 'Q',
        44: 'R',
        45: 'S',
        46: 'T',
        47: 'U',
        48: 'V',
        49: 'W',
        50: 'X',
        51: 'Y',
        52: 'Z',
        /* PUNCTUATION */
        53: '!',
        54: '"',
        55: '#',
        56: '$',
        57: '%',
        58: '&',
        59: '\'',
        60: '(',
        61: ')',
        62: '*',
        63: 'Plus',
        64: ',',
        65: '-',
        66: '.',
        67: '/',
        68: ':',
        69: ';',
        70: '<',
        71: '=',
        72: '>',
        73: '?',
        74: '@',
        75: '[',
        76: '\\',
        77: ']',
        78: '^',
        79: '_',
        80: '`',
        81: '{',
        82: '|',
        83: '}',
        84: '~',
        /* FUNCTION KEYS */
        85: 'F1',
        86: 'F2',
        87: 'F3',
        88: 'F4',
        89: 'F5',
        90: 'F6',
        91: 'F7',
        92: 'F8',
        93: 'F9',
        94: 'F10',
        95: 'F11',
        96: 'F12',
        97: 'F13',
        98: 'F14',
        99: 'F15',
        100: 'F16',
        101: 'F17',
        102: 'F18',
        103: 'F19',
        104: 'F20',
        105: 'F21',
        106: 'F22',
        107: 'F23',
        108: 'F24',
        /* NUMPAD DIGITS */
        109: 'num0',
        110: 'num1',
        111: 'num2',
        112: 'num3',
        113: 'num4',
        114: 'num5',
        115: 'num6',
        116: 'num7',
        117: 'num8',
        118: 'num9'
    },
    id2symbol: {
        /* MODIFIERS */
        256: '⌥',
        512: '⌘',
        1024: '⌃',
        2048: '⇧',
        /* SPECIAL CHARACTERS */
        1: '⌫',
        2: '⇪',
        3: '⌦',
        4: '↓',
        5: '↘',
        6: '⏎',
        7: '⎋',
        8: '↖',
        9: '⎀',
        10: '←',
        11: '⇟',
        12: '⇞',
        13: '→',
        14: '␣',
        15: '⇥',
        16: '↑',
        /* DIGITS */
        17: '0',
        18: '1',
        19: '2',
        20: '3',
        21: '4',
        22: '5',
        23: '6',
        24: '7',
        25: '8',
        26: '9',
        /* ALPHABET */
        27: 'A',
        28: 'B',
        29: 'C',
        30: 'D',
        31: 'E',
        32: 'F',
        33: 'G',
        34: 'H',
        35: 'I',
        36: 'J',
        37: 'K',
        38: 'L',
        39: 'M',
        40: 'N',
        41: 'O',
        42: 'P',
        43: 'Q',
        44: 'R',
        45: 'S',
        46: 'T',
        47: 'U',
        48: 'V',
        49: 'W',
        50: 'X',
        51: 'Y',
        52: 'Z',
        /* PUNCTUATION */
        53: '!',
        54: '"',
        55: '#',
        56: '$',
        57: '%',
        58: '&',
        59: '\'',
        60: '(',
        61: ')',
        62: '*',
        63: '+',
        64: ',',
        65: '-',
        66: '.',
        67: '/',
        68: ':',
        69: ';',
        70: '<',
        71: '=',
        72: '>',
        73: '?',
        74: '@',
        75: '[',
        76: '\\',
        77: ']',
        78: '^',
        79: '_',
        80: '`',
        81: '{',
        82: '|',
        83: '}',
        84: '~',
        /* FUNCTION KEYS */
        85: 'F1',
        86: 'F2',
        87: 'F3',
        88: 'F4',
        89: 'F5',
        90: 'F6',
        91: 'F7',
        92: 'F8',
        93: 'F9',
        94: 'F10',
        95: 'F11',
        96: 'F12',
        97: 'F13',
        98: 'F14',
        99: 'F15',
        100: 'F16',
        101: 'F17',
        102: 'F18',
        103: 'F19',
        104: 'F20',
        105: 'F21',
        106: 'F22',
        107: 'F23',
        108: 'F24',
        /* NUMPAD DIGITS */
        109: 'Numpad0',
        110: 'Numpad1',
        111: 'Numpad2',
        112: 'Numpad3',
        113: 'Numpad4',
        114: 'Numpad5',
        115: 'Numpad6',
        116: 'Numpad7',
        117: 'Numpad8',
        118: 'Numpad9' // numpad9
    },
    triggerKeyBitmask: 255 // Bitmask that includes all trigger keys and none of the modifiers
};
/* EXPORT */
exports.default = Consts;
